import React from "react";
import Header from "../../Components/Header";
import HomeSlide from "../../Components/Home/HomeSlide";
import For from "../../Components/Home/For";
import { Container } from "react-bootstrap";
import Livetalent from "../../Components/Home/Livetalent";
import Ourspecialites from "../../Components/Home/Ourspecialites";
import Exploreourblog from "../../Components/Home/Exploreourblog";
import Ourvision from "../../Components/Home/Ourvision";
import Aboutascent from "../../Components/Home/Aboutascent";
import SuccessStories from "../../Components/Home/SuccessStories";
import Lookingtohire from "../../Components/Home/Lookingtohire";
import Footer from "../../Components/Footer";

function Home() {
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0, overflowY: "hidden" }}>
        <div>
          <Header title="home"/>
        </div>

        <div>
          <HomeSlide />
        </div>

        <div>
          <For />
        </div>

        <div>
          <Livetalent />
        </div>

        <div>
          <Ourspecialites />
        </div>

        <div>
          <Exploreourblog />
        </div>

        <div>
          <Ourvision />
        </div>

        <div>
          <Aboutascent />
        </div>

        <div>
          <SuccessStories />
        </div>

        <div>
          <Lookingtohire />
        </div>

        <div>
          <Footer />
        </div>
      </Container>
    </div>
  );
}

export default Home;
